import {
  HttpClient, HttpParams, HttpRequest,
  HttpResponse, HttpEventType, HttpHeaders, HttpErrorResponse
} from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { BaseEntity, ID } from '../model/baseentity';
import { AppConfig, APP_CONFIG, TableDef } from '../meta/appconfig';

/**
 * å¯¹HTTPçè®¿é®å°è£ï¼ææçREST-APIè®¿é®åéè¦éè¿æ¬å·¥å·ç±»å®æè®¿é®ã
 * æ¬å·¥å·å¨è®¿é®çæ¶åä¼æ ¹æ®æåµå¯¹å°åè¿è¡åè£ï¼ä»¥éåºä¸åçè¿è¡ç¯å¢ã
 *
 * @export
 */
@Injectable()
export class AppRest {
  /**
   * Creates an instance of AppRest.
   * @param HttpClient http
   * @param AppConfig appConfig
   */
  constructor(public http: HttpClient,
    @Inject(APP_CONFIG) public appConfig: AppConfig) {
    console.log('init apprest...');
  }

  /**
   * å¨æéç½®REST-APIå°åï¼ä¸è¬ä¸éè¦è°ç¨
   * å¨EXEçæ¬ä¸­éè¦å¨åºç¨åå§åçæ¶åè¿è¡è°ç¨
   * @param AppConfig appConfig
   * @memberof AppRest
   */
  init(appConfig: AppConfig) {
    this.appConfig = appConfig;
  }

  getUrl(res: string, id?: string) {
    // let url: string = api.loginUrl === res || api.logoutUrl === res
    //   ? res : api.baseUrl + res;
    if (res.startsWith('http')) {
      return res + (id ? '/' + id : '');
    }

    // ä¸ºåç«¯ç¬ç«è¿è¡æ·»å å¿è¦çåç¼
    let url = this.appConfig.baseUrl && this.appConfig.baseUrl !== '/'
      ? this.appConfig.baseUrl + '/' + res
      : res;

    if (id) {
      url = url + '/' + id;
    }

    return url;
  }

  getById<T extends BaseEntity>(res: string, id: string, params?: object): Observable<T> {
    return this.get(res + '/' + id, params);
  }

  private _get(res: string, params?: string | object, options?: any): Observable<any> {
    let url = this.getUrl(res);
    if (params) {
      url += '?' + jqParams(params);
    }
    url = encodeURI(url);
    return this.http.get(url, options)
  }


  get(res: string, params?: string | object, options?: any): Observable<any> {
    return this._get(res, params, options);
  }

  getList(res: string, params?: object, options?: any): Observable<object[]> {
    return this._get(res, params, options)
      .pipe(map(data => {
        if (Array.isArray(data)) {
          return data;
        } else {
          return [data];
        }
      }));
  }

  postFile(url: string, fieldName: string,
    file: File, fileName?: string): Observable<ProgressInfo> {
    const formdata: FormData = new FormData();
    formdata.append(fieldName, file, fileName || file.name);
    if (fileName) {
      formdata.append('fileName', fileName);
    }
    const req = new HttpRequest('POST',
      this.getUrl(url), formdata, { reportProgress: true });

    let lastPi: ProgressInfo = {
      loaded: 0,
      total: 0,
      progress: 0,
      done: false
    };
    return this.http.request(req).pipe(map(ev => {
      if (ev.type === HttpEventType.UploadProgress) {
        lastPi = {
          loaded: ev.loaded,
          total: ev.total,
          progress: Math.round(100 * ev.loaded / ev.total),
          response: ev,
          done: false
        };
      } else if (ev instanceof HttpResponse) {
        lastPi = {
          ...lastPi,
          progress: 100,
          response: ev,
          done: true
        };
      } else {
        // return { progress: -1, response: ev, done: false };
      }
      return lastPi;
    }));
  }

  post(res: string, obj?: object, asForm?: boolean): Observable<any> {
    if (asForm && obj) {
      let pm = new HttpParams();
      if (obj) {
        // tslint:disable-next-line:forin
        for (const prop in obj) {
          pm = pm.set(prop, obj[prop]);
        }
      }

      return this.http.post(this.getUrl(res), pm);
    } else {
      return this.http.post(this.getUrl(res), obj);
    }
  }
  postForm(res: string, formData: FormData, headers?: HttpHeaders | {
    [header: string]: string | string[];
  }): Observable<any>;
  // tslint:disable-next-line:unified-signatures
  postForm(res: string, formData: HttpParams, headers?: HttpHeaders | {
    [header: string]: string | string[];
  }): Observable<any>;
  postForm(res: string, formData: any, headers?: HttpHeaders | {
    [header: string]: string | string[];
  }) {
    let opt = headers ? { headers: headers } : null;
    return this.http.post(this.getUrl(res), formData, opt);
  }

  delete(res: string, params?: object): Observable<any>;
  delete(res: string, form?: FormData): Observable<any>;
  delete(res: string, id: string, params?: object): Observable<any>;
  delete(res: string, params: any, params2?: object): Observable<any> {
    if (typeof params === 'string') {
      let url = this.getUrl(res, params);
      if (params2) {
        url += '?' + jqParams(params2);
      }
      url = encodeURI(url);

      return this.http.delete(url);

    } else if (params instanceof FormData) {
      let req = new HttpRequest<any>("DELETE", res, params, {
        responseType: 'json'
      })

      return this.http.request(req);
    } else {
      let pms = new HttpParams();
      if (params && typeof params == 'object') {
        // tslint:disable-next-line:forin
        for (const p in params) {
          pms = pms.set(p, params[p]);
        }
      }
      if (params2 && typeof params2 == 'object') {
        // tslint:disable-next-line:forin
        for (const p in params2) {
          pms = pms.set(p, params2[p]);
        }
      }

      // this.http.request()
      return this.http.delete(this.getUrl(res),
        { params: pms });
    }
  }

  save(res: string, entity: BaseEntity): Observable<any> {
    if (entity.id) {
      return this.post(res + '/' + entity.id, entity);
    } else {
      return this.post(res, entity);
    }
  }

  uploadFile(url: string, file: File, params?: { [prop: string]: any }): Observable<ProgressInfo> {
    const form = new FormData();
    form.append('file', file, file.name);
    if (params) {
      // tslint:disable-next-line:forin
      for (const prop in params) {
        form.append(prop, params[prop]);
      }
    }

    const req = new HttpRequest('POST',
      this.getUrl(url), form, {
      reportProgress: true,
      withCredentials: true,
    });

    let lastPi: ProgressInfo = {
      loaded: 0,
      total: 0,
      progress: 0,
      done: false
    };

    return this.http.request(req).pipe(
      map(ev => {
        if (ev.type === HttpEventType.UploadProgress) {
          lastPi = {
            loaded: ev.loaded,
            total: ev.total,
            progress: Math.round(100 * ev.loaded / ev.total),
            done: false
          };
        } else if (ev.type === HttpEventType.Response) {
          if (ev.status === 200) {
            lastPi = {
              loaded: file.size,
              total: file.size,
              progress: 100,
              done: true,
              response: ev.body
            };
          }
        } else {
          // return { loaded: 0, total: -1, progress: -1, done: false };
        }
        return lastPi;
      }),
      catchError((err: HttpErrorResponse) =>
        of({ error: err.error || err.message || 'ä¸ä¼ å¤±è´¥ï¼' }))
    );
  }

  downloadFile(url: string): Observable<ProgressInfo> {
    const req = new HttpRequest('GET',
      this.getUrl(url), {
      reportProgress: true,
      responseType: 'blob',
      withCredentials: true
    });

    let lastPi: ProgressInfo = {
      loaded: 0,
      total: 0,
      progress: 0,
      done: false
    };

    return this.http.request(req).pipe(
      map(ev => {
        if (ev.type === HttpEventType.DownloadProgress) {
          lastPi = {
            loaded: ev.loaded,
            total: ev.total,
            progress: Math.round(100 * ev.loaded / ev.total),
            done: false
          };
        } else if (ev.type === HttpEventType.Response) {
          const blob = ev.body as Blob;
          lastPi = {
            loaded: blob.size,
            total: blob.size,
            progress: 100,
            blob,
            done: true
          };
          // } else {
          //   return { loaded: 0, total: -1, progress: -1, done: false };
        }
        return lastPi;
      }),
      catchError((err: HttpErrorResponse) =>
        of({ error: err.error || err.message || 'ä¸è½½å¤±è´¥ï¼' }))
    );
  }

  ajaxDownload(url: string, callbak: (ev: ProgressInfo) => void) {
    url = this.getUrl(url);

    const xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';  // è¿åç±»åblob
    xhr.onloadstart = (ev) => {
      callbak({ total: ev.total, loaded: 0, progress: 0, done: false });
    };
    xhr.onprogress = (ev) => {
      // console.log("down...." + ev.total + "/" + ev.loaded)
      callbak({
        total: ev.total, loaded: ev.loaded,
        progress: Math.round(100 * ev.loaded / ev.total), done: false
      });
    };
    xhr.onerror = function (ev) {
      callbak({
        total: ev.total, loaded: ev.loaded, done: false,
        error: this.statusText
      });
    };
    // å®ä¹è¯·æ±å®æçå¤çå½æ°
    xhr.onload = function (ev) {
      // è¯·æ±å®æ
      if (this.status === 200) {
        // è¿å200
        const blob = this.response;
        callbak({ total: ev.total, loaded: ev.loaded, done: true, blob });
      } else {
        console.log('error...' + this.status + '/' + this.statusText);
        callbak({ total: ev.total, loaded: ev.loaded, error: this.statusText });
      }
    };
    // åéajaxè¯·æ±
    xhr.send();
  }

  ajaxUpload(url: string, file: File, params?: { [prop: string]: any }): Observable<ProgressInfo> {
    const form = new FormData();
    form.append('file', file, file.name);
    if (params) {
      // tslint:disable-next-line:forin
      for (const prop in params) {
        form.append(prop, params[prop]);
      }
    }
    return new Observable(obserer => {
      const xhr = new XMLHttpRequest();
      xhr.withCredentials = true;
      xhr.open('POST', url, true);
      xhr.responseType = 'json';  // è¿åç±»åblob

      // const token = this.app.stateService.loginInfo.jwtToken;
      // if (token) {
      //   const JWT = `Bearer ${token}`;
      //   headers['Authorization'] = JWT;
      //   xhr.setRequestHeader('Authorization',JWT);
      // }

      xhr.setRequestHeader("X-Requested-With", 'XMLHttpRequest');

      let doNext = (pi: ProgressInfo) => {
        let ppi = {
          ...pi, abort: () => {
            xhr.abort();
            obserer.error({ ...pi, error: 'åæ¶ä¸ä¼ ' });
          }
        };
        obserer.next(ppi);
      };

      xhr.onloadstart = (ev) => {
        doNext({ total: ev.total, loaded: 0, progress: 0, done: false });
      };

      if (xhr.upload) {
        xhr.upload.addEventListener('progress', (ev: any) => {
          doNext({
            total: ev.total, loaded: ev.loaded,
            progress: Math.round(100 * ev.loaded / ev.total), done: false
          });
        });
      }

      xhr.onprogress = (ev) => {
        console.log("down...." + ev.total + "/" + ev.loaded);
        doNext({
          total: ev.total, loaded: ev.loaded,
          progress: Math.round(100 * ev.loaded / ev.total), done: false
        });
      };
      xhr.onerror = function (ev) {
        //console.dir(console.dir(ev));
        doNext({
          total: ev.total, loaded: ev.loaded, done: false,
          error: this.statusText
        });
        obserer.error(new Error('ä¸ä¼ éè¯¯'));
      };
      // å®ä¹è¯·æ±å®æçå¤çå½æ°
      xhr.onload = function (ev) {
        // è¯·æ±å®æ
        if (this.status >= 200 && this.status < 300) {
          // è¿å200
          //console.dir(ev);
          doNext({ total: ev.total, progress: 100, loaded: ev.loaded, done: true, response: this.response });
          obserer.complete();
        } else {
          console.log('error...' + this.status + '/' + this.statusText);
          doNext({
            total: ev.total, progress: Math.round(100 * ev.loaded / ev.total), loaded: ev.loaded,
            error: this.statusText
          });
        }
      };
      // åéajaxè¯·æ±
      xhr.send(form);
    });
  }
}

// tslint:disable-next-line:no-shadowed-variable
export function jqParams(a: any, encode: boolean = false): string {
  // tslint:disable-next-line:one-variable-per-declaration
  const s: any = [], rbracket = /\[\]$/,
    isArray = (obj: any) => Array.isArray(obj)
    , add = (k: any, v: any) => {
      v = typeof v === 'function' ? v() : v === null ? '' : v === undefined ? '' : v;
      if (encode) {
        s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v);
      } else {
        s[s.length] = k + '=' + v;
      }

    }, buildParams = (prefix: any, obj: any) => {
      // tslint:disable-next-line:one-variable-per-declaration
      let i: any, len: any;

      if (prefix) {
        if (isArray(obj)) {
          for (i = 0, len = obj.length; i < len; i++) {
            if (rbracket.test(prefix)) {
              add(prefix, obj[i]);
            } else {
              buildParams(prefix + '[' + (typeof obj[i] === 'object' ? i : '') + ']', obj[i]);
            }
          }
        } else if (obj && typeof obj == 'object') {

          // tslint:disable-next-line:forin
          for (const key in obj) {
            buildParams(prefix + '[' + key + ']', obj[key]);
          }
        } else {
          add(prefix, obj);
        }
      } else if (isArray(obj)) {
        for (i = 0, len = obj.length; i < len; i++) {
          add(obj[i].name, obj[i].value);
        }
      } else {
        // tslint:disable-next-line: forin
        for (const key in obj) {
          buildParams(key, obj[key]);
        }
      }
      return s;
    };
  if (typeof a === 'string') {
    return a;
  } else {
    return buildParams('', a).join('&').replace(/%20/g, '+');
  }
}

export interface ProgressInfo {
  filename?: string;
  progress?: number; // percent
  loaded?: number;
  total?: number;
  done?: boolean;
  blob?: Blob;
  error?: string;
  response?: any;
  abort?: () => void;
}
